import axiosClient from "./axiosClient";

const planningApi = {
  async getBlocages(params = {}) {
    const response = await axiosClient.get("/blocages/", { params });
    return response.data;
  },

  async getEvenements(params = {}) {
    const response = await axiosClient.get("/evenements/", { params });
    return response.data;
  },

  async getReservations(params = {}) {
    const response = await axiosClient.get("/reservations/", { params });
    return response.data;
  },
};

export const { getBlocages, getEvenements, getReservations } = planningApi;
export default planningApi;
